import { Filters } from '@/entities/Document';

export const BOOLEAN_FIELDS: (keyof Filters)[] = ['hasTraining', 'isExternal'];

export const DATE_FIELDS: (keyof Filters)[] = [
  'elaborationDate',
  'approvalDate',
  'effectiveDate',
  'validFrom',
  'validUntil',
  'requestDate',
  'validityDate',
  'verificationDate',
];
